import { useState } from 'react';
import Intro from '../messages/Intro';
import NaviButton from './NaviButton';
import YearsCollection from './../controls/Years.json';
import './Navigation.css';

const Navigation = ( props: any ) => {

    const [ currentArrow, updateArrow ] = useState('Years ⇓');
    const [ yearMenu, toggleMenu ] = useState(false);
    const [ years, updateList ] = useState([<></>]);
    const year:any = [];

    const toggleYearMenu = () => {

        updateArrow('Years ⇑');

        for( let i = 1959; i < 1988; i++) {

            if( i > 1958 && i < 1984 || i > 1985 && i < 1988) {
                year.push(<button className='yearMenuItem' onClick={() => {
                    let selectedYear = null;
                    let selectedDir = null;
                    let selectedCollection = null;
    
                    if(i == 1959) { 
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1959'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1960) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1960'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1961) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1961'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1962) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1962'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1963) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1963'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1964) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1964'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1965) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1965'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1966) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1966'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1967) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1967'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1968) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1968'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1969) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1969'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1970) {  
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1970'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1971) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1971'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1972) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1972'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1973) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1973'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1974) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1974'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1975) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1975'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1976) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1976'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1977) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1977'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1978) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1978'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1979) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1979'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1980) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1980'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1981) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1981'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1982) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1982'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1983) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1983'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1986) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1986'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else if(i == 1987) {
                        selectedYear = i.toString();
                        selectedCollection = YearsCollection['1987'];
                        selectedDir = '/USDB' + i.toString() + '/' + i.toString() + 'Page';
                    } else {
                        console.log('something eerie has happened');
                    }
    
                    console.log(selectedCollection?.length);
    
                    props.updatePage(
                        <div className='book-cover'>
                            <div className='cover-year'>
                                Year: {selectedYear}
                            </div>
                            <div className='cover-button-open'>
                                <button className='cover-button' onClick={() => {
                                    props.toggler(false);
                                }}>
                                    Open this yearbook...
                                </button>
                            </div>
                        </div>
                    )
                    props.pdf1(selectedDir + '1.pdf');
                    props.pdf2(selectedDir + '2.pdf');
                    props.selectedCollection(selectedCollection);
                    props.viewNext(selectedYear);
                    props.toggler(true);
                    updateArrow('Years ⇓');
                    toggleMenu(false);
                }}>
                    {i.toString()}
                </button>);
            } else {
                console.log('something... something definitely eeire just has happened...')
            }
        }
    
        updateList(year);
        console.log(years);
    }

    return (
        <div className='navigation'>
            <div className='navigation-bar'>
                <div className='brand'>
                    <NaviButton name='USDB Yearbooks Archive' css='brand' update={props.updatePage} thisPage={<Intro />} />
                </div>
                <button className='years' onClick={() => {
                toggleMenu(!yearMenu);
                toggleYearMenu();
                }}>
                    {currentArrow} 
                </button>
            </div>
            <div className='yearMenu'>
            { yearMenu ?
                <div className='yearsListMenu'>
                    {years}
                </div> 
                :
                <div>

                </div>
            }
            </div>
        </div>
    );
}

export default Navigation;